import { Col } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { TextColors } from "../../../../Constant";
import { TEXT_COLOR } from "../../../../Data/UiKit/HelperClasses";

export const TextColor = () => {
  return (
    <Col xl="3" sm="6">
      <div className="border-wrapper alert-light-light h-100 dark-helper">
        <H4 className="mb-3">{TextColors}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="helper-box helper-text border txt-primary">C </div>
          <span>.txt-primary</span>
        </div>
        {TEXT_COLOR.map(({ className, className2 }, index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-box helper-text border ${className} ${className2 && className2}`}>C </div>
            <span>.{className}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
